import { Map } from 'immutable';
import { createStore, applyMiddleware } from 'redux';
import { createProvider, connect as reactReduxConnect } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
export const storeKey = 'cmp_store';

const defaultReducer = (state) => state;

const logger = createLogger({
    stateTransformer(state) {
        let n = {};
        for (const key in state) {
            n[key] = Map.isMap(state[key]) ? state[key].toJS() : state[key];
        }
        return n;
    }
});

/**
 * Store配置接口
 * @param {*} initState 初始状态
 */
export function configStore(initState) {
    let middleware = null;
    if (process.env.NODE_ENV == 'development') {
        middleware = applyMiddleware(ReduxThunk, logger);
    } else {
        middleware = applyMiddleware(ReduxThunk);
    }
    return createStore(defaultReducer, initState, middleware);
}

let Store = configStore({});

/**
 * 加入setState方法，提供设置state功能
 * @param {*} state 
 */
Store.setState = (initState) => {
    Store.replaceReducer((state, action) => action.state || {});
    Store.dispatch({
        type: 'INIT',
        state: initState
    });
};
export default Store;

/**
 * 自定义的Provider，在context内注册名称为editor_store的store对象
 */
export const Provider = createProvider(storeKey);
/**
 * 和上面的Provider配套的connect，从context中获取名为editor_store的store对象进行订阅
 */
export function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    return reactReduxConnect(mapStateToProps, mapDispatchToProps, mergeProps, {
        storeKey: storeKey
    });
}





// WEBPACK FOOTER //
// ./_source/cqsx/services/store.js